/**
 * Public site origin for canonical URLs, robots, sitemap, and metadata.
 * Prefer NEXT_PUBLIC_APP_URL so the custom domain wins on Vercel (VERCEL_URL
 * is the *.vercel.app hostname and can cause crawler redirect chains).
 */
export function getSiteOrigin() {
  const raw =
    process.env.NEXT_PUBLIC_APP_URL ||
    (process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : null) ||
    "https://tools.idxsolana.io";
  const withProtocol = raw.startsWith("http") ? raw : `https://${raw}`;
  return new URL(withProtocol).origin;
}
